<template>
  <div class="modal modal-invite" id="inviteModal">
    <div class="modal-wrap ">
      <div class="sheet-panel" :class="{ loading: loading }">
        <div class="sheet-header">
          <h3>Add users</h3>
          <button @click="$toggleInviteModal()" class="close-modal">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <div class="sheet-content modal-scroll">
          <div class="row">
            <div class="col-12 mb-3">
              <h3>Import by email</h3>
              <textarea
                placeholder="Paste email addresses as comma separated list"
                id="emailList"
              />
            </div>
            <div class="col-md-12 text-right">
              <button
                class="btn btn-outline-primary mb-2"
                @click="importEmails()"
              >
                Import emails
              </button>
            </div>
            <div class="col-12">
              <h3>Add users to group</h3>
              <table class="table table-invite table-striped">
                <tr>
                  <th>Email</th>
                  <th>First name</th>
                  <th>Last name</th>
                  <th></th>
                </tr>
                <tr v-bind:key="index" v-for="(person, index) in emailList">
                  <td>
                    <b-form-input
                      v-model="person.email"
                      :state="person.validation"
                      v-on:blur="validateField(person, index)"
                      placeholder="Email address"
                      type="email"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      v-model="person.firstName"
                      placeholder="First name"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      v-model="person.lastName"
                      placeholder="Last name"
                    ></b-form-input>
                  </td>
                  <td>
                    <button
                      class="btn-row btn-negative"
                      @click="deleteRow(person)"
                      title="Remove row"
                      v-tippy="{ theme: 'navy' }"
                    >
                      <font-awesome-icon icon="times" />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b-form-input
                      ref="addEmail"
                      v-model="add.email"
                      :state="addState"
                      v-on:blur="validateAdd()"
                      placeholder="Email address"
                      type="email"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      v-model="add.firstName"
                      placeholder="First name"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      v-model="add.lastName"
                      placeholder="Last name"
                    ></b-form-input>
                  </td>
                  <td>
                    <button
                      class="btn-row btn-positive"
                      @click="addRow()"
                      :class="{ disabled: !add.validation }"
                      title="Add user"
                      v-tippy="{ theme: 'navy' }"
                    >
                      <font-awesome-icon icon="plus" />
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="sheet-footer text-right">
          <button class="btn btn-link" @click="$toggleInviteModal()">
            Cancel
          </button>
          <button class="btn btn-primary" @click="addUsers()">
            Add to group
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";

export default {
  name: "FriendsModal",
  components: {},
  props: {
    groupId: String,
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["organisationData"]),
    ...mapState(["groupsData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getGroupsData() {
      return this.groupsData ? this.groupsData : "";
    },
    getOrganisationData() {
      return this.organisationData ? this.organisationData : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    selectedGroupData() {
      if (this.getGroupsData) {
        return this.getGroupsData.find((o) => o.id === this.groupId);
      } else {
        return false;
      }
    },
    addState() {
      return this.add.validation;
    },
  },
  data() {
    return {
      loading: false,
      tagField: null,
      emailList: [],
      add: {
        firstName: "",
        lastName: "",
        email: "",
        validation: null,
      },
      tagifySettings: {
        delimiters : ",| |:|[\\n\\r]",
        whitelist: [],
        callbacks: {},
      },
    };
  },
  mounted: function() {
    let list = document.getElementById("emailList");
    this.tagField = new Tagify(list, this.tagifySettings);
  },
  methods: {
    validateEmail(email) {
       // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateAdd() {
      if (this.add.email === "") {
        this.add.validation = null;
      } else if (!this.validateEmail(this.add.email)) {
        this.add.validation = false;
      } else {
        this.add.validation = true;
      }
    },
    validateField(item, index) {
      if (!this.validateEmail(item.email)) {
        this.emailList[index].validation = false;
      } else {
        this.emailList[index].validation = true;
      }
    },
    validateFields() {
      let fieldsValid = true;
      this.emailList.forEach((item, index) => {
        if (!this.validateEmail(item.email)) {
          this.emailList[index].validation = false;
          fieldsValid = false;
        } else {
          this.emailList[index].validation = true;
        }
      });
      return fieldsValid;
    },
    addUsers() {
      if (!this.validateFields()) {
        return false;
      }
      this.loading = true;
      let addUsers = firebase.functions().httpsCallable("addUsers");

      if (this.add.email !== "" || this.add.validate) {
        this.addRow();
      }

      addUsers({
        groupId: this.selectedGroupData.id,
        organisationId: this.getOrganisationData.id,
        organisationName: this.getOrganisationData.name,
        users: this.emailList,
      })
        .then((result) => {
          this.loading = false;
          this.emailList = [];
          if (result.data) {
            let count = result.data.length;
            this.$toast.open({
              message: count + " user(s) added to the group",
              type: "success",
            });
            this.loading = false;
            this.$toggleInviteModal();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addRow() {
      let row = {
        email: this.add.email,
        firstName: this.add.firstName,
        lastName: this.add.lastName,
        validation: null,
      };
      this.emailList.push(row);
      this.add.email = "";
      this.add.firstName = "";
      this.add.lastName = "";
      this.add.validation = null;
      this.$refs.addEmail.focus();
    },
    deleteRow(person) {
      this.emailList.splice(this.emailList.indexOf(person), 1);
    },
    importEmails() {
      let list = this.tagField.value;
      list.forEach((item) => {
        let found = false;
        let error = false;
        this.emailList.forEach((subItem) => {
          if (subItem.email === item.value) {
            found = true;
          }
        });
        if (this.selectedGroupData.users) {
          this.selectedGroupData.users.forEach((subItem) => {
            if (subItem.email === item.value) {
              found = true;
            }
          });
        }
        if (!this.validateEmail(item.value)) {
          error = true;
        }
        if (!found && !error) {
          let email = item.value;
          var fullName = email.split("@")[0].split(".");
          let firstName = "";
          let lastName = "";

          if (fullName.length === 2) {
            firstName = fullName[0];
            firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
            lastName = fullName[1];
            lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
          } else if (fullName.length === 3) {
            firstName = fullName[0];
            firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
            lastName = fullName[2];
            lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
          }

          let doc = {
            email: item.value,
            firstName: firstName,
            lastName: lastName,
            validation: null,
          };
          this.emailList.push(doc);
        } else {
          if (found) {
            this.$toast.open({
              message: "User with email already exists",
              type: "error",
            });
          } else if (error) {
            this.$toast.open({
              message: "Badly formatted email address",
              type: "error",
            });
          }
        }
      });
      this.tagField.removeAllTags();
      this.validateFields();
    },
  },
};
</script>
